import {
  GET_STAFFROLES, GET_STAFFROLES_COMPLETED, GET_STAFFROLES_FAILED,
  GET_CASHIER, GET_CASHIER_COMPLETED, GET_CASHIER_FAILED,
  ADD_CASHIER, ADD_CASHIER_COMPLETED, ADD_CASHIER_FAILED,
  UPDATE_CASHIER, UPDATE_CASHIER_COMPLETED, UPDATE_CASHIER_FAILED,
  SEARCH_STAFF_ROLES, SEARCH_STAFF_ROLES_COMPLETED, SEARCH_STAFF_ROLES_FAILED,
} from './actions';
import {AUTH_LOGOUT} from "../Auth/actions";
import {handleSearch, handleSearchCompleted, handleSearchFailed, searchDefault} from "../utils/search";

const defaultState = {
  staffRolesLoading: false,
  staffRoles: [],
  staffRolesError: null,
  staffRoleLoading: false,
  staffRole: null,
  staffRoleError: null,
  addingStaffRole: false,
  updatingStaffRole: false,
  search: searchDefault,
};

const staffRoleReducer = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case SEARCH_STAFF_ROLES: return handleSearch(state, 'search', action.payload);
    case SEARCH_STAFF_ROLES_COMPLETED: return handleSearchCompleted(state, 'search', action.payload);
    case SEARCH_STAFF_ROLES_FAILED: return handleSearchFailed(state, 'search', action.payload);
    case GET_STAFFROLES: {
      return {
        ...state,
        staffRolesLoading: true,
        staffRoles: [],
        staffRolesError: null,
      };
    }
    case GET_STAFFROLES_COMPLETED: {
      return {
        ...state,
        staffRolesLoading: false,
        staffRoles: action.payload.data,
      };
    }
    case GET_STAFFROLES_FAILED: {
      return {
        ...state,
        staffRolesLoading: false,
        staffRolesError: action.payload,
      };
    }
    case GET_CASHIER: {
      return {
        ...state,
        staffRoleLoading: true,
        staffRole: null,
        staffRoleError: null,
      };
    }
    case GET_CASHIER_COMPLETED: {
      return {
        ...state,
        staffRoleLoading: false,
        staffRole: action.payload,
      };
    }
    case GET_CASHIER_FAILED: {
      return {
        ...state,
        staffRoleLoading: false,
        staffRoleError: action.payload,
      };
    }
    case ADD_CASHIER: {
      return {
        ...state,
        addingStaffRole: true,
      };
    }
    case ADD_CASHIER_COMPLETED: {
      return {
        ...state,
        addingStaffRole: false,
      };
    }
    case ADD_CASHIER_FAILED: {
      return {
        ...state,
        addingStaffRole: false,
      };
    }
    case UPDATE_CASHIER: {
      return {
        ...state,
        updatingStaffRole: true,
      };
    }
    case UPDATE_CASHIER_COMPLETED: {
      return {
        ...state,
        updatingStaffRole: false,
      };
    }
    case UPDATE_CASHIER_FAILED: {
      return {
        ...state,
        updatingStaffRole: false,
      };
    }
    case AUTH_LOGOUT: {
      return defaultState;
    }
    default:
      return state;
  }
};

export default staffRoleReducer;



// WEBPACK FOOTER //
// ./src/StaffRole/reducer.js